import { render, staticRenderFns } from "./DCVehicleRegistration.vue?vue&type=template&id=5b60a669&"
import script from "./DCVehicleRegistration.vue?vue&type=script&lang=js&"
export * from "./DCVehicleRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports